import { KeycloakType } from "../providers/KeycloakProvider";

const isUserOfType = (keycloak: KeycloakType, role: string) => keycloak?.realmAccess?.roles.includes(role);

export const isUserParticipant = (keycloak: KeycloakType) => isUserOfType(keycloak, "participant");

export const isUserCaseManager = (keycloak: KeycloakType) => isUserOfType(keycloak, "case_manager");

export const isUserProvider = (keycloak: KeycloakType) => isUserOfType(keycloak, "provider");

export const isUserStaff = (keycloak: KeycloakType) => isUserOfType(keycloak, "staff");

export const isUserStaffAdmin = (keycloak: KeycloakType) => isUserOfType(keycloak, "staff_admin");
